import { isDefined } from "@clipboard-health/util-ts";
import { DialogContent, Stack } from "@mui/material";
import { Button } from "@src/appV2/redesign/components/Button";
import { DialogFooter } from "@src/appV2/redesign/components/DialogFooter";
import { SelectableBox } from "@src/appV2/redesign/components/SelectableBox";
import { Text } from "@src/appV2/redesign/system/ui-components";

import {
  FOOTER_BUTTON_MIN_WIDTH,
  TB_TEST_TYPE_SELECTION_DESCRIPTIONS,
  TB_TEST_TYPE_SELECTION_LABELS,
  TB_TEST_TYPE_SELECTION_OPTIONS,
  type TestTypeSelectionOption,
} from "../constants";

interface TestTypeSelectionStepProps {
  selectedOption: TestTypeSelectionOption | undefined;
  onSelectedOptionChange: (option: TestTypeSelectionOption) => void;
  onConfirm: (selection: TestTypeSelectionOption) => void;
  onBack: () => void;
}

export function TestTypeSelectionStep(props: TestTypeSelectionStepProps) {
  const { selectedOption, onSelectedOptionChange, onConfirm, onBack } = props;

  return (
    <>
      <DialogContent>
        <Stack spacing={8}>
          <Text variant="h3">Which TB test have you completed recently?</Text>

          <Stack spacing={4}>
            {TB_TEST_TYPE_SELECTION_OPTIONS.map((option) => {
              const label = TB_TEST_TYPE_SELECTION_LABELS[option];
              const description = TB_TEST_TYPE_SELECTION_DESCRIPTIONS[option];

              return (
                <SelectableBox
                  key={option}
                  variant="secondary"
                  isSelected={selectedOption === option}
                  sx={(theme) => ({
                    backgroundColor: theme.palette.background.quaternary,
                    borderColor: theme.palette.border?.primary,
                    textAlign: "left",
                  })}
                  onToggleSelect={() => {
                    onSelectedOptionChange(option);
                  }}
                >
                  <Stack gap={2}>
                    <Text variant="body1">{label}</Text>
                    {isDefined(description) && (
                      <Text
                        variant="body2"
                        sx={(theme) => ({ color: theme.palette.text.secondary })}
                      >
                        {description}
                      </Text>
                    )}
                  </Stack>
                </SelectableBox>
              );
            })}
          </Stack>
        </Stack>
      </DialogContent>

      <DialogFooter withShadow orientation="horizontal">
        <Button
          size="large"
          variant="text"
          sx={{ minWidth: FOOTER_BUTTON_MIN_WIDTH }}
          onClick={onBack}
        >
          Back
        </Button>
        <Button
          size="large"
          disabled={!isDefined(selectedOption)}
          variant="contained"
          sx={{ minWidth: FOOTER_BUTTON_MIN_WIDTH }}
          onClick={() => {
            if (isDefined(selectedOption)) {
              onConfirm(selectedOption);
            }
          }}
        >
          Next
        </Button>
      </DialogFooter>
    </>
  );
}
